<!--模板导入 页面-->
<template>
  <div class="gray-back">
    <!--    <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">-->
    <!--      <van-tab title="正常"></van-tab>-->
    <!--      <van-tab title="隐藏"></van-tab>-->
    <!--    </van-tabs>-->
    <!--    <div class="box yundongyuan-box">-->
    <!--      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">-->
    <!--        <van-list-->
    <!--            v-model="loading"-->
    <!--            :finished="finished"-->
    <!--            finished-text="没有更多了"-->
    <!--            @load="onLoad"-->
    <!--        >-->
    <!--          <div class="kaojicenter-list-box">-->
    <!--            <div class="kaojicenter-lists flex-between" v-for="(item, index) in list"-->
    <!--                 @click="action(item, index)">-->
    <!--              <div class="kaojicenter-rights">-->
    <!--                <div class="title">{{ item.name }}</div>-->
    <!--                <div class="desc flex-start">-->
    <!--                  <van-tag round v-if="item.cert_status==1" type="success">已认证</van-tag>-->
    <!--                  <van-tag round v-else-if="item.cert_status==3">认证失败</van-tag>-->
    <!--                  <van-tag round v-else-if="item.cardtype==1 && item.cert_status==2" type="warning">未认证</van-tag>-->
    <!--                  <van-tag round plain v-else-if="item.cardtype!=1 && item.cert_status==2">无需认证</van-tag> &nbsp;-->
    <!--                  {{ item.num }}-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </van-list>-->
    <!--      </van-pull-refresh>-->

    <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect"/>

    <div class="savebtn">
      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal"  @click="download" round>模版下载
      </van-button>
      <van-uploader
          accept=".xls,.xlsx"
          :after-read="readFile"
      >
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round>导入模板
        </van-button>
      </van-uploader>

    </div>
    <van-popup :close-on-click-overlay="false" v-model="showLoading">
      <div class="">
        <van-circle style="display: block;margin: 0 auto;" :stroke-width="60" :color="{
                                '0%': '#ffad19',
                                '100%': '#fec835',
                              }" v-model="progress" :rate="progress" :speed="100" :text="progress+'%'"/>
        <van-button
            style="width: 3rem; margin-top: 10px"
            size="normal" round>上传中
        </van-button>
      </div> 
      <div>
      </div>

    </van-popup>

    <van-dialog v-model="showError" title="批量导入错误信息" style="height: 80%;
    width: 80%!important;" class="error-box" :closeOnClickOverlay="true">
      <van-cell-group>
        <van-cell :title="item" :key="key" v-for="(item,key) in errorMsg"/>
      </van-cell-group>
    </van-dialog>
  </div>
</template>
<style scoped>
.error-box >>> .van-dialog__content {
  overflow-y: scroll;
  height: 100%;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.kaojicenter-list-box {
  padding-top: 0.2rem;
  /*background: rgba(248,248,248,1);*/
}

.goods-line {
  height: 55px;
}

.goods-bottom-line {
  width: 100%;
  position: fixed;
  height: 60px;
  bottom: 0;
  background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
}

.goods-create-btn {
  position: fixed;
  bottom: 10px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  text-align: center;
}

.goods-create-btn button {
  width: 3.2rem;
}

.goods-create-btn img {
  width: 60px;
  height: 60px;
}

.goods-header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  margin-bottom: 0.01rem;
  background: #fff;
}

.van-tabs {
  /*width: 85% !important;*/
}

.screen-btn {
  line-height: 44px;
  height: 44px;
}

.screen-btn img {
  width: 45%;
  padding-left: 15px;
  vertical-align: middle;
  border-left: 1px solid #D5D5D5;
}

.sidebar {
  padding-top: 15px;
}

.search-box img {
  width: 60px;
  height: 60px;
}


.select-btn {
  position: fixed;
  bottom: 0;
  width: 90%;
  margin: 0 auto;
  padding: 0px 15px 30px;
}

.btn-reset {
  padding-bottom: 10px;
}

.btn-reset >>> .van-button {
  background: #ddd;
}

.selected {
  color: #444;
}


.kaojicenter-lists {
  padding: 0.2rem;
  border-radius: 10px;
  background: #fff;
  margin: 0 0.2rem 0.2rem;
}

.kaojicenter-lefts {
  position: relative;
}


.kaojicenter-lefts .img {
  border-radius: 10px;
  width: 1rem;
  height: 1rem;
}

.kaojicenter-rights {
  width: calc(100% - 1.2rem);
  position: relative;
  height: 1rem;
}

.kaojicenter-rights .title {
  font-size: 15px;
  font-weight: bold;
}

.kaojicenter-rights .desc {
  font-size: 12px;
  padding-top: 10px;
  color: #999;
}

.yundongyuan-box >>> .van-popup {
  background: none;
}

.circle-div {
  text-align: center;
}

.circle-div >>> .van-circle__text {
  color: #fff !important;
}
</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  Progress,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';
import XLSX from "xlsx";

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(Progress).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'ExameApplyDetailShare',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      showDate: false,
      showError: false,
      showLoading: false,
      progress: 0,
      actionShow: false,
      addShow: false,
      list: [],
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他身份证明'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        user_id: 0,
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        grade: '',
        csize: '',
        num: '',
        numtype: 1,
        birthday:'',
        sex:1,
        is_exam_continue: 2,
        kaoji_id: this.$route.query.id,
        share_id: 0,
        user_id: this.$route.query.user_id,
        name: '',
        score_total: 0
      },
      formDataRs: {
        baoming_id: 0,
        user_id: 0,
        member_list: []
      },
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false,


      listData: [],
      errorMsg: [], // 错误列表
      index: 0,
      memberList: [],
      memberFinalList: [], //合并后的申请数据
      startNum: 3,
      file:{},
      file_url:'',
    }
  },
  mounted() {
    document.title = "七彩星级考级人员管理"
    let user_id = this.formDataRs.user_id = this.$route.query.user_id
    this.formDataRs.id = this.$route.query.id
    if (!user_id) {
      Toast.fail('请输入正确的链接')
      return
    }
  },
  computed: {},
  filters: {},
  destroyed() {
  },
  methods: {

    readFile(evt) {
      console.log('------readFile------', evt)
      var that = this;
      that.errorMsg = []
      that.index = 0

      that.showTemplate = false

      that.file = evt.file




      let files = {0: evt.file}

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表
          var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

          // let indexName = "O1"
          // console.log( workbook.Sheets[wsname]);return

          // if (typeof workbook.Sheets[wsname].R1 == 'undefined' || typeof workbook.Sheets[wsname].R1.h == 'undefined' || workbook.Sheets[wsname].R1.h != "版本202301") {
          //   Toast.fail('文件版本不正确，请下载最新版本模板');
          //   return;
          // }


          if (typeof workbook.Sheets[wsname].S1 == 'undefined' || typeof workbook.Sheets[wsname].S1.h == 'undefined' || workbook.Sheets[wsname].S1.h != "版本20240907") {
            Toast.fail('文件版本不正确，请下载最新版本模板');
            return;
          }

          if (that.startNum) {
            list = list.splice(that.startNum, list.length)
          }

          that.progress = 0
          that.listData = list.filter(item =>{
            return typeof item.__EMPTY_3 != 'undefined'
          })
          // let listData = list.filter(row => {
          //   return row.hasOwnProperty("__EMPTY");
          // })
          console.log('onGetData', that.listData )
          // return 
          // return
          that.formatData()

        } catch (e) {
          console.log(e)
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },

    formatData() {
      let that = this
      that.showLoading = true
      that.listData.map((row) => {
        that.addRow(row)
      })

      that.formatList()
    },

    addRow(row) {
      let that = this
      console.log(row)
      // return 
      that.formData.name = row['__EMPTY']
      that.formData.sex = row['__EMPTY_1'] === '男'? 1 : 2
      that.formData.phone = row['__EMPTY_2'] ? row['__EMPTY_2'] : ''
      that.formData.num = row['__EMPTY_3'] ? row['__EMPTY_3'] : ''
      that.formData.numtype = row['__EMPTY_4'] === '护照' ? 2 : 1
      that.formData.totalscore = row['__EMPTY_5'] ? row['__EMPTY_4'] : ''
      that.formData.project = row['__EMPTY_16'] ? row['__EMPTY_16'] : ''

      let grade = '红'
      if(row['__EMPTY_6'] === 1) {
        grade = '幼儿初';
      }else if(row['__EMPTY_7'] === 1) {
        grade = '幼儿中';
      }else if(row['__EMPTY_8'] === 1) {
        grade = '幼儿高';
      }else if(row['__EMPTY_9'] === 1) {
        grade = '红';
      } else if(row['__EMPTY_10'] === 1) {
        grade = '橙';
      }else if(row['__EMPTY_11'] === 1) {
        grade = '黄';
      }else if(row['__EMPTY_12'] === 1) {
        grade = '绿';
      }else if(row['__EMPTY_13'] === 1) {
        grade = '青';
      }else if(row['__EMPTY_14'] === 1) {
        grade = '蓝';
      }else if(row['__EMPTY_15'] === 1) {
        grade = '紫';
      }
      that.formData.grade =grade

      that.memberList.push(that.formData)
      that.setMemberStart()
    },

    setMemberStart() {
      let that = this
      that.formData = {
        grade: '',
        csize: '',
        num: '',
        numtype: 1,
        birthday:'',
        sex:1,
        is_exam_continue: 2,
        kaoji_id: this.$route.query.id,
        user_id: this.$route.query.user_id,
        share_id: 0,
        name: '',
        score_total: 0
      };
    },

    formatList() {
      let that =this
      let newJson = []; //盛放去重后数据的新数组
      console.log('that.memberList',that.memberList)
      for( let item1 of that.memberList){  //循环json数组对象的内容
        let flag = true;  //建立标记，判断数据是否重复，true为不重复
        item1.grades = [item1.grade]
        item1.projects = [item1.project]

        newJson.map((item2, jsonIndex) => {
          if(item1.num===item2.num && item1.grade != item2.grade){ //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
            let grades = item2.grades.concat(item1.grade)
            newJson[jsonIndex].grades = grades

            let projects = item2.projects.concat(item1.project)
            newJson[jsonIndex].projects = projects

            flag = false;
          }
        })

        if(flag){ //判断是否重复
          newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
        }
      }

      // newJson.map(row => {
      //   if(row.name =='吕新') {
      //     console.log(row)
      //   }
      // })

      that.memberFinalList = newJson

      console.log(that.memberList, newJson)

      // that.memberFinalList.map(member => {
        that.checkMemberRow()
        // that.checkMemberRow(member)
      // })
    },

    // checkMemberRow(member) {
    checkMemberRow() {
      let that = this
      let member = that.memberFinalList[that.index];
      that.$api.post('/api/qcxj/checkApplyMemberOk', member, (res) => {
        console.log('checkApplyMemberOk');
        console.log(res);
        if(res.data.length > 0) {
          that.errorMsg = that.errorMsg.concat(res.data)
        }

        that.getProgress()
      }, (res) => {
        that.getProgress()
      })
    },

    getProgress() {
      let that = this
      that.index += 1

      let index = that.index,
          list = that.memberFinalList

      let progress = parseInt((index / (list.length + 1)) * 100) 

      that.progress = progress;
      if (index === list.length) {
        if (that.errorMsg.length > 0) {
          // 唤起弹框
          that.memberList = []
          that.showLoading = false
          that.showError = true
        } else {
          that.uploadFile()
          that.kaojiMemberAdd()
        }
      }else{
        that.checkMemberRow()
      }
    },

    uploadFile(){
      let that = this
      let ossAccessTokenURL = 'https://api.ccachina.net/core/attachment/aliOssSts';
      let ossFileURL= 'https://ccago.oss-cn-hangzhou.aliyuncs.com';
      OSS.urllib.request(ossAccessTokenURL, {method: 'GET'}, function (err, response) {
        let result;
        if (err) {
          that.$toast.$toast('上传异常:' + err);
          that.loadding = false;
          console && console.error(err);
          return;
        }
        try {
          result = JSON.parse(response);
        } catch (e) {
          that.loadding = false;
          return alert('parse sts response info error: ' + e.message);
        }
        var client = new OSS.Wrapper({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          endpoint: result.data.endpoint,
          bucket: result.data.bucket,
          secure: true
        });
        var suffix = that.file.name.toLowerCase().split('.').splice(-1)[0];
        var myDate = new Date();
        var file_save_name = 'uploader/' + that.getNowFormatDate()  + '/kaoji-apply-' + that.formDataRs.id + '-'+that.file.lastModified+'.' + suffix;
        console.log(file_save_name);
        let thisfile = this;
        client.multipartUpload(file_save_name, that.file).then(function (result) { 
          console.log('success');
          console.log(file_save_name,result);   

          that.$api.post('/api/qcxj/fileadd', {
            'id' : that.formDataRs.id,
            'url': result.url
          }, (res) => { 
          }, (res) => {
          })


        }).catch(function (err) {
          console.log('文件上传失败');
          console.log(err);
          that.loadding = false;
          that.$toast('文件上传失败');
        });
      });


    },

    kaojiMemberAdd() {
      let that = this


      that.$api.post('/api/qcxj/applyMemberAllSave', {
        'list': JSON.stringify(that.memberFinalList)
      }, (res) => {
        that.memberList = []
        that.showLoading = false
        // that.getProgress()
        Toast.success('批量导入成功')
      }, (res) => {
      })
    },

    download() {
      console.log('donwload')
      let that = this;
      // window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-30/1627624869864169.xlsx')
      // window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-09-22/1632295303675106.xlsx')
      // 携带版本确认的模板文件
      // window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2022-02-10/1644478877052797.xlsx')
      // window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1675133663652-7/%E5%95%A6%E5%95%A6%E6%93%8D%E4%B8%83%E5%BD%A9%E6%98%9F%E7%BA%A7%E8%BF%90%E5%8A%A8%E5%91%98%E8%AF%81%E4%B9%A6%E7%94%B3%E8%AF%B7%E8%A1%A82023.xlsx.xlsx')
      // window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1725613524867-4/%E5%95%A6%E5%95%A6%E6%93%8D%E4%B8%83%E5%BD%A9%E6%98%9F%E7%BA%A7%E8%BF%90%E5%8A%A8%E5%91%98%E8%AF%81%E4%B9%A6%E7%94%B3%E8%AF%B7%E8%A1%A82024.xlsx.xlsx')
      window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1725674663781-3/%E5%95%A6%E5%95%A6%E6%93%8D%E4%B8%83%E5%BD%A9%E6%98%9F%E7%BA%A7%E8%BF%90%E5%8A%A8%E5%91%98%E8%AF%81%E4%B9%A6%E7%94%B3%E8%AF%B7%E8%A1%A8202409.xlsx.xlsx')
      return
      appEvent({
        name: 'downloadFile',
        query: {
          name: '考级人员信息导入表模板',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-16/1626404860889325.xlsx'
        }
      });
    },

    action(item, index) {
      return
      this.actionShow = true;
      this.params.id = item.id;
      this.params.name = item.name;
      this.actions = [];
      if (item.is_show == 1) {
        this.actions.push({name: '隐藏'});
      } else {
        this.actions.push({name: '显示'});
      }
      if (item.cert_status == 2) {
        this.actions.push({name: '认证'});
      } else {
      }

    },
    onActionSelect(action, index) {
//                console.log(action); return ;
      let that = this;
      switch (index) {
        case 0 :
          if (action.name == '隐藏') {
            Dialog.confirm({
              title: '确认',
              message: '是否隐藏该运动员?',
            })
                .then(() => {
                  // on confirm
                  that.$api.post('/api/yundongyuan/hide', {
                    id: that.params.id
                  }, (res) => {
                    that.onRefresh();
                  }, (res) => {
                    Toast.fail(res.msg);
                  })

                })
                .catch(() => {
                  // on cancel
                });
          } else {
            that.$api.post('/api/yundongyuan/show', {
              id: that.params.id
            }, (res) => {
              that.onRefresh();
            }, (res) => {
              Toast.fail(res.msg);
            })
          }

          this.actionShow = false;
          break;

        case 1 :
          //认证
          // on confirm
          that.$api.post('/api/yundongyuan/cert', {
            id: that.params.id
          }, (res) => {
            that.onRefresh();
          }, (res) => {
            Toast.fail(res.msg);
          })
          break;

        case 2 :


          break;

      }
      this.actionShow = false;
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      // that.getList();
    },

    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      this.formData.birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit() {

    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onFamilyIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.jianhuname = data.name;
      this.formData.jianhunum = data.cardNum;
    },
    onIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.name = data.name;
      this.formData.num = data.cardNum;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/add', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.onRefresh();
        that.formData = {
          name: '',
          num: '',
          huzhao: '',
          cardtype: 1,
          birthday: '',
          sex: 1,
          numTypeName: '身份证',
          jianhuname: '',
          jianhunum: '',
          jianhuphone: '',
        };
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },


    getNowFormatDate: function () {
      var date = new Date();
      var seperator1 = "";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return  year + seperator1 + month + seperator1 + strDate;
    },

    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },


  }
}
</script>



// WEBPACK FOOTER //
// ExameApplyDetailShare.vue?260684d4